<template>
    <div class="edit-cabinet-dialog">
        <el-dialog
            :visible.sync="visible"
            :title="$t('Reception.Fifth.change_status')"
            left>
            <el-form
                ref="form"
                :model="form"
                :status-icon="true"
                label-position="right"
                label-width="133px"
                label-suffix=":">
                <el-form-item :label="$t('Common.store')">
                    <span>{{ form.storeName }}</span>
                </el-form-item>
                <el-form-item :label="$t('Reception.Fourth.area1')">
                    <span>{{ form.storeAreaName }}</span>
                </el-form-item>
                <el-form-item :label="$t('Reception.Fourth.number')">
                    <span>{{ form.lockerCode }}</span>
                </el-form-item>
                <el-form-item :label="$t('Reception.Fifth.status')">
                    {{ form.status }}
                </el-form-item>
                <el-form-item
                    class="edit-cabinet-status"
                    prop="statusCode"
                    :label="$t('Reception.Fifth.change_status2')">
                    <el-select
                        class="pr-2 reception-store"
                        v-model="form.status"
                        @change="fetchStatus"
                        :placeholder="$t('Reception.Fifth.choose_status')">
                        <el-option
                            v-for="(item, index) in options"
                            :key="`${index}-${item.code}`"
                            :label="item.name"
                            :value="Number(item.code)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    v-if="form.status == '2'"
                    class="edit-cabinet-label"
                    label="$t('Reception.Fifth.name_phone')">
                    <!-- 远程搜索 -->
                    <el-select
                        v-model="form.clientId"
                        filterable
                        remote
                        reserve-keyword
                        :placeholder="$t('Reception.Fifth.place_name_phone')"
                        :remote-method="fetchUser">
                        <el-option
                            v-for="item in options4"
                            :key="item.id"
                            :label="item.resultText"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">{{ $t('Common.cancel') }}</el-button>
                <el-button @click="confirm" type="primary">{{ $t('Common.submit') }}</el-button>
            </span>
        </el-dialog>
    </div>

</template>

<script>
import { Dialog } from 'element-ui';

export default {
    name: 'edit-cabinet',
    components: {
        ElDialog: Dialog,
    },
    data() {
        return {
            visible: false,
            form: {
                status: '',
                clientId: '',
            },
            stores: [],
            options: [
                {
                    code: 1,
                    name: this.$t('Reception.Fifth.option1'),
                }, {
                    code: 2,
                    name: this.$t('Reception.Fifth.option2'),
                }, {
                    code: 3,
                    name: this.$t('Reception.Fifth.option3'),
                }, {
                    code: 4,
                    name: this.$t('Reception.Fifth.option4'),
                }, {
                    code: 5,
                    name: this.$t('Reception.Fifth.option5'),
                }, {
                    code: 6,
                    name: this.$t('Reception.Fifth.option6'),
                },
            ],
            options4: [],
            id: null,
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            this.$refs.form.resetFields();
        },
        async open(id) {
            this.id = id;
            await this.fetchData();
            this.visible = true;
        },
        fetchStatus() {
            this.form.staus = this.form.status;
        },
        fetchData() {
            API.get(`temporary-locker/${this.id}`).then(res => {
                res.statusCode = this.options.find(el => el.name === res.status).code;
                res.clientId = null;
                this.form = res;
                this.form.status = res.statusCode;
            });
        },
        fetchUser(val) {
            // 获取用户的接口
            API.get(`client/search/`, {
                params: {
                    keyword: val,
                },
            }).then(res => {
                this.options4 = res;
            });
        },
        confirm() {
            let query = {
                status: this.form.status,
                clientId: Number(this.form.status == 1) ? null :this.form.clientId,
                temporaryClientId: Number(this.form.status == 1) ? null :this.form.clientId,
            };
            if (query.status === 2 && !(query.clientId)) return $ele.$message($t('Reception.Fifth.fill_in_info'));
            API.put(`temporary-locker/${this.id}`, query).then(res => {
                $ele.$message.success(this.$t('Message.success'));
                this.$emit('fetchData');
                this.visible = false;
            });
        },
    },
};
</script>

<style lang="scss">
.edit-cabinet-dialog {
    .el-dialog {
        width: 430px;
        height: 470px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
}
// 使用者
.edit-cabinet-label {
    // .el-form-item__label {
    //     width: 140px !important;
    // }
    .el-select {
        width: 100%;
    }
    // .el-form-item__content {
    //     margin-left: 140px !important;
    // }
}
// 状态
.edit-cabinet-status {
    .el-select {
        width: 120px;
    }
}
</style>
